// Per-portal PWA identity. Admin, Client and Driver can each be saved to a
// home screen as a separate app, so the <link rel="manifest"> in <head> has to
// follow the portal the user is currently looking at — "Add to Home Screen"
// reads whatever manifest is attached at that moment, and each manifest carries
// its own start_url (the matching login route) and short_name.
//
// Kept free of React/router imports so the routing rules can be unit-tested.

const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const PORTALS = {
  admin:  { manifest: "manifest-admin.json",  title: "DRIVN Admin" },
  client: { manifest: "manifest-client.json", title: "DRIVN Client" },
  driver: { manifest: "manifest-driver.json", title: "DRIVN Driver" },
};

const STAFF_ROLES = ["admin", "allocator"];

const isUnder = (pathname, base) => pathname === base || pathname.startsWith(`${base}/`);

// Which portal does this page belong to? Login/driver routes are unambiguous.
// Everywhere else (dashboard, public pages) fall back to the signed-in role,
// and to Client for anonymous visitors — the public site's "Login" is the
// client login.
export function portalForRoute(pathname, role) {
  if (isUnder(pathname, "/driver-login") || isUnder(pathname, "/driver-dashboard")) return "driver";
  if (isUnder(pathname, "/admin-login")) return "admin";
  if (isUnder(pathname, "/client-login") || pathname === "/login") return "client";
  if (role === "driver") return "driver";
  if (STAFF_ROLES.includes(role)) return "admin";
  return "client";
}

// Point the document head at the portal's manifest + iOS home-screen label.
// The manifest <link> is replaced rather than edited in place, which browsers
// pick up more reliably than a changed href.
export function applyPortal(key, doc = document) {
  const portal = PORTALS[key] || PORTALS.client;
  const href = `${PUBLIC_URL}/${portal.manifest}`;

  const current = doc.querySelector('link[rel="manifest"]');
  if (!current || current.getAttribute("href") !== href) {
    if (current) current.remove();
    const link = doc.createElement("link");
    link.setAttribute("rel", "manifest");
    link.setAttribute("href", href);
    doc.head.appendChild(link);
  }

  let title = doc.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (!title) {
    title = doc.createElement("meta");
    title.setAttribute("name", "apple-mobile-web-app-title");
    doc.head.appendChild(title);
  }
  title.setAttribute("content", portal.title);
}
